import React, { useEffect, useState } from 'react';

import { useKeycloak } from '@react-keycloak/web';

import RedirectToKeycloak from './RedireactToKeycloak';
import useSessionStorage from '../../App/Component/useSessionStorage';
import {
  getKeyCloakRealmFromLS,
  removeKeyCloakRealmOnLS,
} from '../../Authentication/Actions/authentication';
import DocumentLibraryProvider from '../../DocumentLibrary/Component/DocumentLibraryProvider';
import BarLoader from '../../UniversalComponents/Loader/barLoader';

interface IProps {
  handleKeycloakRealmNameChange: (realmName: string) => void;
  children: React.ReactNode;
}

const PrivateRoute: React.FC<IProps> = ({
  handleKeycloakRealmNameChange,
  children,
}) => {
  const { keycloak, initialized } = useKeycloak();
  const keycloakRealmName = getKeyCloakRealmFromLS();
  const isLoggedIn = keycloak.authenticated;
  const [loadingTime, setLoadingTime] = useState(0);

  const handleKeycloakRedirection = () => {
    if (keycloak && !isLoggedIn) {
      keycloak.login();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (isLoggedIn) {
        //do nothing
      } else if (!initialized && loadingTime === 1) {
        removeKeyCloakRealmOnLS();
        window.location.reload();
      }
    }, 2000);
  }, [isLoggedIn, loadingTime, initialized]);

  const [accessToken] = useSessionStorage<any>('accessToken');

  if (!initialized) {
    setTimeout(() => {
      setLoadingTime(1);
    }, 20000);

    return <BarLoader />;
  } else if (isLoggedIn && accessToken !== undefined) {
    return <DocumentLibraryProvider>{children}</DocumentLibraryProvider>;
  } else {
    return (
      <RedirectToKeycloak
        keycloakRealmName={keycloakRealmName}
        handleKeycloakRedirection={handleKeycloakRedirection}
        handleKeycloakRealmNameChange={handleKeycloakRealmNameChange}
      />
    );
  }
};

export default PrivateRoute;
